import Vue from "vue";
import Router from "vue-router";

//活动中心路由
import ActiveRouter from "./_active.js";
import ActiveManageRouter from "./_active_manage.js";


//用户中心路由
import UserRouter from "./_user.js";

//营销中心路由
import MarketRouter from "./_market.js";

//企业信息路由
import EnterpriseRouter from "./_enterprise.js";

//系统设置路由
import ChannelRouter from "./_channel.js";

// 获取原型对象push函数
const originalPush = Router.prototype.push;
// 获取原型对象replace函数
const originalReplace = Router.prototype.replace;
// 修改原型对象中的push函数
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/menu", // 顶部菜单
      component: (resolve) => require(["@/views/menu.vue"], resolve),
      redirect: "/menu/home",
      children: [
        {
          path: "home", // 首页
          name: "mainpage",
          component: (resolve) => require(["@/views/home/home.vue"], resolve),
        },
        {
          path: "homes", // 首页
          name: "mainpages",
          component: (resolve) => require(["@/views/home/homes.vue"], resolve),
        },
        {
          path: "user",
          component: (resolve) => require(["@/views/user/index.vue"], resolve),
          redirect: "/menu/user/list",
          children: UserRouter,
        },
        {
          path: "active", // 活动模块
          redirect: "/menu/active/list",
          component: (resolve) => require(["@/views/active/index.vue"], resolve),
          children: ActiveRouter,
        },
        {
          path: "active/:id",
          name: "activeManage",
          redirect: "/menu/active/:id/index",
          component: (resolve) => require(["@/views/active/manage/index.vue"], resolve),
          children: ActiveManageRouter,
        },
        // {
        //   path: "clue/:ts", // 线索模块
        //   name: "clue",
        //   component: (resolve) => require(["../views/clue.vue"], resolve),
        // },
        // {
        //   path: "website/:ts", // 网站中心
        //   name: "website",
        //   component: (resolve) => require(["../views/website.vue"], resolve),
        // },
        {
          path: "yhh/:ts", // 友户会
          name: "yhh",
          component: (resolve) => require(["../views/yhh.vue"], resolve),
        },
        {
          path: "helpdoc", // 帮助文档
          component: (resolve) => require(["@/views/helpdoc.vue"], resolve),
        },
        {
          path: "download", // 下载页面
          name: "download",
          component: (resolve) => require(["../views/downloadPage.vue"], resolve),
        },
        {
          path: "market",
          redirect: "/menu/market/email",
          component: (resolve) => require(["@/views/market/index.vue"], resolve),
          children: MarketRouter,
        },
        {
          path: "setting",
          component: (resolve) => require(["@/views/setting/index.vue"], resolve),
          redirect: (to) => {
            if (sessionStorage.getItem("systemFlag") == "组织账号") {
              return "/menu/setting/enterprise";
            } else {
              return "/menu/setting/channel/list";
            }
          },
          children: [
            {
              path: "enterprise",
              component: (resolve) => require(["@/views/setting/emptyRouterView.vue"], resolve),
              redirect: "/menu/setting/enterprise/org",
              children: EnterpriseRouter,
            },
            {
              path: "channel",
              component: (resolve) => require(["@/views/setting/emptyRouterView.vue"], resolve),
              redirect: "/menu/channel/list",
              children: ChannelRouter,
            },
            {
              path: "wechat",
              component: (resolve) => require(["@/views/setting/emptyRouterView.vue"], resolve),
              redirect: "/menu/wechat/list",
              children: [
                {
                  path: "list",
                  component: (resolve) => require(["../views/setting/wechat/list.vue"], resolve),
                },
                {
                  path: "type",
                  component: (resolve) => require(["../views/setting/wechat/type.vue"], resolve),
                },
              ],
            },
            {
              path: "signupForm",
              component: (resolve) => require(["@/views/setting/emptyRouterView.vue"], resolve),
              redirect: "/menu/setting/signupForm/list",
              children: [
                {
                  path: "list",
                  component: (resolve) => require(["../views/setting/signupForm/list.vue"], resolve),
                },
              ],
            },
            {
              path: "menu",
              component: (resolve) => require(["@/views/setting/menu.vue"], resolve),
            },
          ],
        },
        {
          path: "content",
          component: (resolve) => require(["@/views/content/index.vue"], resolve),
          redirect: "/menu/content/featured",
          children: [
            {
              path: "field/:type",
              name: "content/field",
              meta: {
                nameText: "自定义字段",
                isFirst: true,
              },
              component: () => import("../views/content/field/index.vue"),
            },
            {
              path: "featured",
              name: "featured",
              meta: {
                nameText: "聚合页",
                isFirst: true,
              },
              component: () => import("../views/content/featured/index.vue"),
            },
            {
              path: "featured/:id",
              name: "featuredEdit",
              meta: {
                nameText: "聚合页",
              },
              component: () => import("../views/content/featured/edit.vue"),
            },
            {
              path: "featured/:id/count",
              name: "featuredCount",
              meta: {
                nameText: "聚合页统计",
              },
              component: () => import("../views/content/featured/count.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "*",
      redirect: "/menu/home",
    },
    {
      path: "/login",
      component: (resolve) => require(["@/views/login.vue"], resolve),
    },
    {
      path: "/forget",
      component: (resolve) => require(["@/views/forget.vue"], resolve),
    },
    {
      path: "/findbyphone",
      component: (resolve) => require(["@/views/findbyphone.vue"], resolve),
    },
    {
      path: "/register",
      component: (resolve) => require(["@/views/register.vue"], resolve),
    },
    {
      path: "/weixincallback", // 微信扫码后回调页面
      component: (resolve) => require(["@/modules/weixin/pages/weixinCallback.vue"], resolve),
    },
    {
      path: "/serviceTerms",
      component: (resolve) => require(["@/views/terms/serviceTerms.vue"], resolve),
    },
    {
      path: "/privacyTerms",
      component: (resolve) => require(["@/views/terms/privacyTerms.vue"], resolve),
    },
    {
      path: "/marketTerms",
      component: (resolve) => require(["@/views/terms/marketTerms.vue"], resolve),
    },
    {
      path: "/customerRecordList",
      component: (resolve) => require(["@/views/user/customerRecordList.vue"], resolve),
    },
  ],
  mode: "hash",
  linkActiveClass: "active",
});
